import styled from 'styled-components';
import { Form } from 'formik';

export const StyledUserPanelEmployeeElement = styled(Form)`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
